var _g, _g2, _g3, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogofinal = function SvgLogofinal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 354 307",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_1952)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_30_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4703 86.5336H293.53V127.228H280.316V175.861H287.787V134.847H301V78.8715H185.721C203.075 76.5303 223.655 72.0394 238.262 63.4834C282.272 37.6452 250.789 -13.0098 214.645 3.1019C202.784 8.38023 192.026 18.6389 182.912 30.0256C179.52 34.2611 176.357 38.6668 173.444 43.0299C163.248 58.2902 156.235 73.0611 153.613 78.8502H151.387C148.786 73.0611 141.752 58.2902 131.556 43.0299C128.643 38.6668 125.48 34.2824 122.088 30.0256C112.974 18.6389 102.195 8.38023 90.3553 3.1019C54.211 -13.0098 22.7277 37.6239 66.7377 63.4834C81.3245 72.0394 101.925 76.509 119.279 78.8715H4V134.847H17.2134V276H24.6837V127.206H11.4703V86.5336V86.5336ZM255.242 33.0905C264.065 55.9278 204.677 72.1459 168.366 78.8927H154.862C180.831 51.3305 245.254 7.23093 255.242 33.0905ZM49.7787 33.0905C59.7668 7.23093 124.19 51.3305 150.159 78.8927H136.654C100.364 72.1459 40.9767 55.949 49.7787 33.0905Z",
    fill: "#F7F7F7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_30_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.928 243.032C90.9787 244.003 93.4747 245.875 95.416 248.648C97.3573 251.421 98.328 254.576 98.328 258.112C98.328 263.867 96.456 268.304 92.712 271.424C89.0373 274.475 83.8373 276 77.112 276H47.784V212.144H75.136C81.8613 212.144 87.096 213.635 90.84 216.616C94.584 219.597 96.456 223.896 96.456 229.512C96.456 232.84 95.624 235.717 93.96 238.144C92.3653 240.501 90.3547 242.131 87.928 243.032ZM63.696 237.416H73.264C78.256 237.416 80.752 235.475 80.752 231.592C80.752 227.779 78.256 225.872 73.264 225.872H63.696V237.416ZM63.696 249.896V262.272H74.928C77.216 262.272 78.984 261.717 80.232 260.608C81.5493 259.499 82.208 258.008 82.208 256.136C82.208 254.195 81.5493 252.669 80.232 251.56C78.984 250.451 77.216 249.896 74.928 249.896H63.696ZM105.675 212.144H151.331V226.496H122.107V236.48H148.835V250.52H122.107V261.544H151.331V276H105.675V212.144ZM165.74 267.784C159.986 261.613 157.108 253.709 157.108 244.072C157.108 234.435 159.986 226.531 165.74 220.36C171.495 214.189 178.844 211.104 187.788 211.104C195.484 211.104 201.69 213.149 206.404 217.24C211.188 221.331 214.17 226.773 215.348 233.568H198.708C196.836 228.368 193.196 225.768 187.788 225.768C183.49 225.768 180.092 227.467 177.596 230.864C175.17 234.261 173.956 238.664 173.956 244.072C173.956 249.411 175.17 253.813 177.596 257.28C180.092 260.677 183.49 262.376 187.788 262.376C193.266 262.376 196.906 259.741 198.708 254.472H215.348C214.17 261.267 211.188 266.744 206.404 270.904C201.69 274.995 195.484 277.04 187.788 277.04C178.844 277.04 171.495 273.955 165.74 267.784ZM263.66 212.144H280.404V276H263.66V250.728H239.012V276H222.268V212.144H239.012V236.376H263.66V212.144ZM349.813 244.072C349.813 253.64 346.901 261.544 341.077 267.784C335.253 273.955 327.73 277.04 318.509 277.04C309.357 277.04 301.869 273.955 296.045 267.784C290.29 261.544 287.413 253.64 287.413 244.072C287.413 234.435 290.29 226.531 296.045 220.36C301.869 214.189 309.357 211.104 318.509 211.104C327.73 211.104 335.253 214.189 341.077 220.36C346.901 226.531 349.813 234.435 349.813 244.072ZM328.909 257.384C331.613 253.987 332.965 249.549 332.965 244.072C332.965 238.595 331.613 234.192 328.909 230.864C326.274 227.467 322.808 225.768 318.509 225.768C314.21 225.768 310.744 227.432 308.109 230.76C305.544 234.088 304.261 238.525 304.261 244.072C304.261 249.619 305.544 254.056 308.109 257.384C310.744 260.712 314.21 262.376 318.509 262.376C322.808 262.376 326.274 260.712 328.909 257.384Z",
    fill: "#F7F7F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_30_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.59 183.618C46.864 179.524 45.001 174.257 45.001 167.817C45.001 161.377 46.864 156.133 50.59 152.085C54.316 147.991 59.031 145.944 64.735 145.944C69.611 145.944 73.567 147.255 76.603 149.877C79.685 152.453 81.64 155.926 82.468 160.296H73.705C72.095 155.972 69.105 153.81 64.735 153.81C61.423 153.81 58.801 155.121 56.869 157.743C54.937 160.319 53.971 163.677 53.971 167.817C53.971 171.911 54.937 175.269 56.869 177.891C58.801 180.513 61.423 181.824 64.735 181.824C69.105 181.824 72.095 179.639 73.705 175.269H82.468C81.64 179.685 79.685 183.204 76.603 185.826C73.567 188.402 69.611 189.69 64.735 189.69C59.031 189.69 54.316 187.666 50.59 183.618ZM101.763 173.199H97.1397V189H88.3767V146.634H105.834C110.388 146.634 113.999 147.807 116.667 150.153C119.335 152.499 120.669 155.811 120.669 160.089C120.669 163.401 119.818 166.138 118.116 168.3C116.414 170.416 114.045 171.842 111.009 172.578L122.187 189H112.251L101.763 173.199ZM97.1397 154.155V165.954H105.282C107.444 165.954 109.1 165.425 110.25 164.367C111.4 163.309 111.975 161.883 111.975 160.089C111.975 158.249 111.4 156.8 110.25 155.742C109.1 154.684 107.444 154.155 105.282 154.155H97.1397ZM140.436 146.634H149.199L165.414 189H156.444L152.649 178.788H136.779L133.053 189H124.221L140.436 146.634ZM144.714 157.26L139.539 171.336H149.889L144.714 157.26ZM179.279 189H170.516V146.634H198.737V154.362H179.279V165.126H197.288V172.785H179.279V189ZM202.807 154.362V146.634H238.963V154.362H225.301V189H216.4V154.362H202.807Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_1952",
    x: 0,
    y: 0,
    width: 305,
    height: 284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_1952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_1952",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_30_1952",
    x: 0,
    y: 0,
    width: 305,
    height: 288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_1952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_1952",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_30_1952",
    x: 43.7839,
    y: 211.104,
    width: 310.029,
    height: 74.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_1952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_1952",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_30_1952",
    x: 41.001,
    y: 145.944,
    width: 201.962,
    height: 52.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_1952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_1952",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogofinal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logofinal.8fc2cc5e.svg";
export { ForwardRef as ReactComponent };